import { __awaiter } from "tslib";
import { useCallback } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { useGetUserProfileQuery } from '@/store/api/cc';
import { addError } from '@/store/slices/notificationsSlice';
import { logError } from '@/utils/logger';
export const useRefreshUserProfile = () => {
    const dispatch = useAppDispatch();
    const { refetch } = useGetUserProfileQuery(undefined);
    const refreshUserProfile = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // Do not call getTokenForced() here (S4R-11053): the Auth0 Action cannot read
        // tenantName during a refresh exchange and emits tenantName: "", which the backend
        // 401s. Restore only after the Action reads from event.resource_server.identifier.
        const { data: userProfile, error } = yield refetch();
        if (error) {
            dispatch(addError({ key: 'ERROR_USER_PROFILE_FETCH' }));
            logError('Failed to fetch user profile', error);
            // Wrap RTK Query error in Error object and attach status
            const wrappedError = new Error('Failed to fetch user profile');
            Object.assign(wrappedError, { status: 'status' in error ? error.status : 500 });
            throw wrappedError;
        }
        if (!userProfile)
            return null;
        return userProfile;
    }), [dispatch, refetch]);
    return refreshUserProfile;
};
export default useRefreshUserProfile;
